function isObj(value) {
  return value && Object.prototype.toString.call(value) === '[object Object]'
}

function isArray(value) {
  return value && Object.prototype.toString.call(value) === '[object Array]'
}

function isString(value) {
  return value && Object.prototype.toString.call(value) === '[object String]'
}

export function isJsonString(str) {
  if (isString(str)) {
    try {
      str = JSON.parse(str)
      if (isObj(str) || isArray(str)) {
        return true
      } else {
        return false
      }
    } catch (e) {
      return false
    }
  }
  return false
}

class SelfStorage {
  constructor(type) {
    this.storageType = type ? type : 'localStorage'
    this.support = false
    this.isSupport()
  }
  isSupport() {
    try {
      if (
        window &&
        typeof window === 'object' &&
        window.Storage &&
        window[this.storageType] &&
        window[this.storageType] instanceof window.Storage
      ) {
        // 探测
        // Safari隐私模式下 localStorage 依然有效但是无法存储
        window[this.storageType].setItem('@@test@@', '@@test@@')
        if (window[this.storageType].getItem('@@test@@') === '@@test@@') {
          window[this.storageType].removeItem('@@test@@')
          this.support = true
          return true
        } else {
          this.support = false
          return false
        }
      } else {
        this.support = false
        return false
      }
    } catch (e) {
      return false
    }
  }
  set(key, value) {
    if (!this.support) {
      return false
    }
    if (!key) {
      return false
    }
    if (typeof value === 'object') {
      window[this.storageType].setItem(key, JSON.stringify(value))
    } else {
      window[this.storageType].setItem(key, value)
    }
    return true
  }
  get(key) {
    if (!this.support) {
      return false
    }
    if (!key) {
      return false
    }
    const value = window[this.storageType].getItem(key)
    if (isJsonString(value)) {
      return JSON.parse(value)
    }
    return value
  }
  clear() {
    if (!this.support) {
      return false
    }
    window[this.storageType].clear()
    return true
  }
  remove(key) {
    if (!this.support) {
      return false
    }
    window[this.storageType].removeItem(key)
    return true
  }
}

const LS = new SelfStorage('localStorage')
const SS = new SelfStorage('sessionStorage')

// 标记详情页浏览次数
export const detailPageViewCount = '@@top-detailPage-viewCount'
// 标记详情页是否已经弹出过引导添加桌面快捷方法的弹窗
export const addDesktopPopup = '@@top-add-desktop-popup-status'
// 标记是否从 game turbo 小窗切换而来
export const isFromGameTurboKey = '@@top-is-from-game-turbo'
// 游戏订单信息
export const gameOrderInfoKey = '@@top-game-orderInfo'
// 标记lordsmobile是否需要弹出sku提示
export const popupSkuTips = '@@top-popup-skuTips'
// 标记lm下单时间，判断是否填写支付信息
export const lmCreateOrderTime = '@@top-lm-createOrder-ts'

export const nickNameStorageKey = '@@top-nickname'
export const serverNameStorageKey = '@@top-server'
// igg游戏只有第一次弹出下单规则提示弹框
export const lmRuleTips = '@@ks-lm-ruleTips'
// 查看订单提示
export const viewOrderTips = '@@ks-viewOrder-tips'
// 引导登录提示
export const loginTips = '@@ks-login-tips'

// 游戏uid
export const gameUidKey = '@@ks-gameUid'
// 游戏zoneid
export const gameZoneidKey = '@@ks-gameZoneid'
// 裂变弹框是否已显示
export const showFissionPopup = '@@ks-fission-popup'
// 裂变弹框显示时间
export const showFissionPopupTime = '@@ks-fission-popup-ts'

// 裂变未登录弹框是否已显示
export const showFissionNologinPopup = '@@ks-fission-nologin-popup'
// 裂变未登录弹框显示时间
export const showFissionNologinPopupTime = '@@ks-fission-nologin-popup-ts'
// 裂变：被分享者携带的分享者的信息
export const fissionGuest2OwnerInfos = '@@ks-fission-guest2Owner-infos'
export const backPageShowFissionPopup = '@@ks-back-page-showFissionPopup'
// 钱包是否在充值中
export const walletIsPaying = '@@wallet-is-paying'
// 钱包在充值中的商品ID  eg:@@wallet-paying-skuid-{game}
export const walletPayingSkuId = `@@wallet-paying-skuid`
// 钱包在充值的订单号
export const walletPayingOrder = `@@wallet-paying-order`
// 是否首次设置密码
export const firstCreatePassword = '@@wallet-first-create-password'
// 裂变活动降落伞
export const fissionParachuteCount = '@@fission-parachute-count'
// 裂变活动降落伞显示时间
export const fissionParachuteTime = '@@fission-parachute-time'
// 记录降落伞“今天”是否弹框
export const fissionParachuteTodayFlag = '@@fission-parachute-today-flag'

// Toplupe主端重构版本
export const toplupeVersion = '@@toplupe-version'
// pubgmUid
export const pubgmUid = '@@pubgm-uid'
export const pubgmUserName = '@@pubgm-userName'

// 会员
export const MembersModalBoxList = '@@MembersModalBoxList'

// 针对 【'freefire-diamonds', 'freefiremax-diamonds'】添加是否为第一次进入的标识
export const firstFFgames = '@@first-load'

// 品牌升级通知条：用户手动关闭后永久不再显示
export const BRAND_UPGRADE_NOTICE_CLOSED = '@@brand-upgrade-notice-closed'
// 品牌升级通知条：首次展示日期（用于 14 天限制）
export const BRAND_UPGRADE_NOTICE_FIRST_DATE =
  '@@brand-upgrade-notice-first-date'
// 品牌升级通知条：当日最后展示日期（用于每天只显示一次）
export const BRAND_UPGRADE_NOTICE_LAST_SHOW = '@@brand-upgrade-notice-last-show'

export const cdvkKey = '@@vk-callback-url'
export const vkStateStorageKey = '@@vk-state'
export const vkCodeVerifierStorageKey = '@@vk-code-verifier'
export const vkTrackParamsStorageKey = '@@vk-track-params'

const illegalValue = ['', null, 'undefined', undefined]

function setObj(val) {
  let newVal = illegalValue.indexOf(val) === -1 ? val : ''
  if (typeof val === 'object') {
    newVal = JSON.stringify(val)
  }
  return newVal
}

function getObj(val) {
  let newVal = illegalValue.indexOf(val) === -1 ? val : ''
  try {
    newVal = JSON.parse(newVal)
  } catch (error) {
    newVal = val
  }
  return newVal
}

// 兼容原来的代码逻辑
const originSetEvent = SS.set
SS.set = function (key, val) {
  const value = setObj(val)
  return originSetEvent.call(SS, key, value)
}

const originGetEvent = SS.get
SS.get = function (key) {
  const value = originGetEvent.call(SS, key)
  return getObj(value || '')
}

export const storage = LS
export const session = SS
